import { render, staticRenderFns } from "./AbkMobileBtn.vue?vue&type=template&id=5fd9700b&scoped=true&"
import script from "./AbkMobileBtn.vue?vue&type=script&lang=js&"
export * from "./AbkMobileBtn.vue?vue&type=script&lang=js&"
import style0 from "./AbkMobileBtn.vue?vue&type=style&index=0&id=5fd9700b&scoped=true&lang=scss&"
import style1 from "./AbkMobileBtn.vue?vue&type=style&index=1&id=5fd9700b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fd9700b",
  null
  
)

export default component.exports